var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.986 16.65h.231l2.346-.528c.467-.092.897-.321 1.233-.659l6.36-6.36a1.392 1.392 0 00.408-.992 1.352 1.352 0 00-.408-.992l-1.715-1.715a1.41 1.41 0 00-1.975 0l-6.49 6.323a2.42 2.42 0 00-.658 1.233l-.464 2.28a1.169 1.169 0 00.316 1.067c.218.214.51.336.816.343zm7.213-10.523a.39.39 0 01.547 0L16.47 7.86a.353.353 0 01.112.269.372.372 0 01-.112.268l-1.103 1.085-2.28-2.28 1.112-1.076zM7.31 13.164c.05-.286.19-.55.399-.751l4.636-4.543 2.29 2.3-4.543 4.589a1.317 1.317 0 01-.714.38l-2.365.482a.12.12 0 01-.13 0 .14.14 0 010-.14l.427-2.317zM18.491 17.976H4.51a.51.51 0 000 1.02H18.49a.51.51 0 000-1.02z",
    fill: "currentColor"
  })));
}
export default SvgEdit;